<template>
	<b-card-text class="container-mobile">
		<loading :active.sync="isLoading" is-full-page loader="bars" color="#00A09C" :width="64" />
		<b-row class="data-card-details">
			<b-col sm="12" md="6" class="pb-3 px-4">
				<b-input-group v-if="!forMultipleInvoice">
					<b-form-input
						type="text"
						v-model="filter"
						:placeholder="FormMSG(31, 'Type to search ...')"
						@keyup.enter="filterInvoices"
						@change="filterInvoices"
					/>
					<b-input-group-append>
						<b-input-group-text>
							<component :is="getLucideIcon(ICONS.SEARCH.name)" color="#06263E" :size="16" :stroke-width="2.5" v-if="filter.length === 0" />
							<component
								:is="getLucideIcon(ICONS.X.name)"
								color="#06263E"
								:size="16"
								:stroke-width="2.5"
								@click="reinitializeFilterInvoices"
								v-else
							/>
						</b-input-group-text>
					</b-input-group-append>
				</b-input-group>
			</b-col>
			<b-col v-if="forApprove || forMultipleInvoice" sm="12" md="6" class="pb-3 px-4 d-flex justify-content-end align-items-center">
				<b-button
					size="md"
					variant="blue-sapphire"
					class="w-200-px d-flex justify-content-center align-items-center"
					style="gap: 7px"
					:disabled="invoicesItems.length === 0"
					v-if="$screen.width >= 992"
					@click="openReviewMode"
				>
					<b-spinner class="mr-2" v-show="loadingReviewMode" small />
					<component v-if="!loadingReviewMode" :is="getLucideIcon('View')" :size="20" />
					<span>{{ FormMSG(164, 'Review mode') }}</span>
				</b-button>
			</b-col>
		</b-row>
		<div v-if="$screen.width <= 992" class="container-mobile">
			<div class="my-expense-mobile">
				<b-overlay :show.sync="isBusy" opacity="0.75" rounded="lg">
					<InvoiceItemMobile
						:forApprove="forApprove"
						:forDraft="forDraft"
						:forPending="forPending"
						:forApproved="forApproved"
						:forMultipleInvoice="forMultipleInvoice"
						:invoiceItems="invoicesItems"
						:notSubmittedState="notSubmittedState"
						:submittedState="submittedState"
						@approveInvoice="approveInvoice"
						@rejectInvoice="rejectInvoice"
						@sendInvoiceForApproval="sendInvoiceForApproval"
						@deleteInvoice="deleteInvoice"
						@setSelectedItem="setSelectedItem"
						@viewInvoiceDetail="viewInvoiceDetails"
					/>
				</b-overlay>
			</div>
		</div>
		<b-table
			v-else
			id="table-clickable"
			ref="invoiceList"
			:hover="hover"
			responsive="sm"
			:items="invoicesItems"
			:fields="invoicesFields"
			:current-page="currentPage"
			:per-page="0"
			bordered
			small
			sticky-header="700px"
			:head-variant="hv"
			:busy="isBusy"
			tbody-tr-class="tr-cursor"
			:empty-text="FormMSG(10, 'No invoice found')"
			@row-clicked="viewInvoiceDetails"
			show-empty
		>
			<template #table-busy>
				<div class="d-flex justify-content-center align-items-center">
					<b-spinner class="align-middle" small></b-spinner>
					<strong class="ml-2">{{ FormMSG(353, 'Loading') }}...</strong>
				</div>
			</template>
			<template #head(select)="" v-if="!forPending && !forApproved">
				<div class="text-center vertical-centered" id="select-all">
					<b-form-checkbox size="lg" v-model="isSelectedAll" @change="setSelectionForAll()" class="cb-border-white" />
				</div>
			</template>
			<template #cell(select)="data" v-if="!forPending && !forApproved">
				<span>
					<b-form-checkbox size="lg" class="pj-cb pb-1" v-model="data.item.selectState" @change="updateSelectedRows(data.item)" />
				</span>
			</template>
			<template #cell(supplierName)="{ item }">
				<div class="d-flex align-items-center" :class="{ 'justify-content-between': item.documents && item.documents.length <= 0 }" style="gap: 7px">
					<span>{{ item.supplierName }}</span>
					<div
						class="mx-2 p-1 border warning-invoice rounded d-flex align-items-center"
						style="gap: 7px"
						v-if="item.documents && item.documents.length <= 0"
					>
						<component :is="getLucideIcon('AlertCircle')" :size="16" :stroke-width="1.5" />
						<span class="small">{{ FormMSG(12, 'no invoice attached') }}</span>
					</div>
				</div>
			</template>
			<template #cell(po)="{ item }">
				<template v-if="item.purchaseOrders && item.purchaseOrders.length > 0">
					<div v-for="po in item.purchaseOrders" :key="po.id">
						<span class="py-2">{{ po.id }}</span>
					</div>
				</template>
				<template v-else>
					<div>
						<span>{{ FormMSG(11, 'No PO') }}</span>
					</div>
				</template>
			</template>
			<template #cell(validatedStatus)="data">
				<div class="d-flex align-items-center justify-content-center flex-row w-100" style="gap: 5px">
					<div v-if="data.item.allExpenseItemIsInContract === false" class="d-flex justify-content-end" style="width: 40%">
						<button
							class="btn-transparent text-color-rhapsody-in-blue"
							v-b-tooltip.left.html
							:title="FormMSG(250, 'This invoice is outside of the user\'s contract dates. You can still validate it')"
						>
							<component :is="getLucideIcon('AlertTriangle')" color="#EA4E" :size="18" />
						</button>
					</div>
					<!-- <div v-else class="d-flex justify-content-end" style="width: 50%"></div> -->
					<div class="d-flex align-items-center justify-content-center wrap-status">
						<div :id="`popover-refused-${data.item.id}`" :class="`status  ${data.item.statusClass}`" style="font-size: 0.7rem">
							{{ data.item.validatedStatus }}
						</div>
						<b-popover :target="`popover-refused-${data.item.id}`" boundary="window" triggers="hover" v-if="isInvoiceRefused(data.item)">
							{{ data.item.comment }}
						</b-popover>
					</div>
				</div>
			</template>
			<template #cell(description)="data">
				<span class="text-description-overflow-ellypsis">
					{{ data.item.description }}
				</span>
			</template>
		</b-table>
		<b-row v-if="$screen.width >= 576" class="mt-3">
			<b-col v-if="forApprove" cols="12">
				<b-button @click="rejectInvoice(selectedRows)" :disabled="selectedRows.length === 0" variant="primary">
					{{ FormMSG(267, 'Reject') }} {{ selectedRows.length >= 1 ? `(${selectedRows.length})` : '' }}
				</b-button>
			</b-col>
			<b-col v-if="forEfcDraft || forDraft || (forMultipleInvoice && selectedRows.length > 0)" :cols="forMultipleInvoice ? 12 : 12">
				<b-button @click="deleteInvoice(selectedRows)" :disabled="selectedRows.length === 0" variant="secondary">
					{{ FormMSG(268, 'Delete') }} {{ selectedRows.length >= 1 ? `(${selectedRows.length})` : '' }}
				</b-button>
				<!-- <component id="monitors" v-if="forMultipleInvoice" class="cursor-pointer ml-2" :is="getLucideIcon('Video')" :stroke-width="1.5" />
				<b-popover target="monitors" triggers="hover focus">
					<div class="d-flex flex-column">
						<div>Single monitor</div>
						<div class="bg-primary">Multiple monitors</div>
					</div>
				</b-popover> -->
			</b-col>
		</b-row>
		<b-modal
			header-class="header-class-modal-doc-package"
			:title="selectedRows.length > 1 ? FormMSG(28, 'Reject these invoices') : FormMSG(26, 'Reject this invoice')"
			class="modal-danger"
			v-model="modalRejectedInvoice"
			no-close-on-backdrop
			no-close-on-esc
			hide-header-close
		>
			<b-form-group :label="FormMSG(25, 'Enter your comment:')" label-for="comment">
				<b-form-textarea id="comment" ref="rejectComment" v-model="rejectComment" rows="3" />
			</b-form-group>
			<template #modal-footer>
				<div class="w-100 d-flex flex-row justify-content-end align-items-center">
					<b-button size="sm" variant="custom-outline-gray" class="w-138-px" block @click="modalRejectedInvoice = false">
						{{ FormMSG(101, 'Close') }}
					</b-button>
					<b-button size="sm" variant="custom-primary-blue" class="w-138-px ml-2" style="margin-top: -1px" @click="finaliseInvoiceReject" block>
						<div :disabled="rejectComment.length === 0" class="d-flex justify-content-center align-items-center">
							<div class="pl-2" style="margin-top: 1px">{{ FormMSG(102, 'Save') }}</div>
						</div>
					</b-button>
				</div>
			</template>
		</b-modal>
	</b-card-text>
</template>

<script>
// utils
import { rendCurrency, formatTableDate } from '~helpers';
import _ from 'lodash';

// mixin
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';
import invoicesToolsMixin from '@/mixins/invoicesTools.mixin';

// props
import mapProps from '@/shared/vuePropsMapper';

// cruds
import { getExpenseToValidate, getMyExpenses, rejectExpenses, deleteExpenses, getInvoiceEntryForCrew } from '@/cruds/expense.crud';

// constants
import { FINANCES, EXPENSE_TYPE, VALIDATION_TYPE, INVOICE_MENUS } from '@/shared/constants';
import { Edit, Eye, Send, Trash2 as Trash } from 'lucide-vue';

// components
import InvoiceItemMobile from './InvoiceItemMobile.vue';
import Loading from 'vue-loading-overlay';

export default {
	name: 'InvoicesDataView',
	mixins: [languageMessages, globalMixin, invoicesToolsMixin],
	components: {
		Edit,
		Eye,
		Send,
		Trash,
		InvoiceItemMobile,
		Loading
	},
	props: {
		...mapProps(['hover', 'striped', 'bordered'], {
			type: Boolean,
			default: true
		}),
		...mapProps(['small', 'fixed', 'loadingReviewMode'], {
			type: Boolean,
			default: false
		}),
		...mapProps(['forApprove', 'forDraft', 'forPending', 'forApproved', 'forMultipleInvoice', 'forEfcDraft', 'forEfcSubmitted'], {
			type: Boolean,
			default: false
		}),
		canApprove: {
			type: Boolean,
			default: true
		},
		notSubmittedState: {
			type: Boolean,
			default: false
		},
		submittedState: {
			type: Boolean,
			default: false
		},
		isBusyDatatable: {
			type: Boolean,
			default: false
		},
		canSeeCrewMember: {
			type: Boolean,
			default: false
		},
		invoiceList: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			filter: '',
			currentPage: 1,
			hv: 'dark',
			invoiceType: 1,
			invoicesItems: [],
			selectedRows: [],
			isSelectedAll: false,
			isBusyDataTable: false,
			offset: null,
			limit: null,
			rejectComment: '',
			selectedInvoice: null,
			modalRejectedInvoice: false,
			isBusy: false,
			isLoading: false
		};
	},
	async mounted() {
		await this.$nextTick();
		await this.initData();
		this.$bus.$on('invoice:reload-data', async () => {
			await this.initData();
		});
	},
	destroyed() {
		// shutdown event bus
		this.$bus.$off('invoice:reload-data');
	},
	computed: {
		invoicesFields() {
			const fields = [
				{
					key: 'invoiceNumber',
					label: this.FormMSG(2, 'Inv. no.'),
					formatter: (v) => `${v}`,
					sortable: true,
					class: 'text-center vertical-centered'
				},
				{
					key: 'date',
					label: this.FormMSG(3, 'Date'),
					formatter: (v) => formatTableDate(v),
					sortable: true,
					class: 'text-center vertical-centered'
				},
				{
					key: 'createdAt',
					label: this.FormMSG(33, 'Due date'),
					formatter: (v) => formatTableDate(v),
					sortable: true,
					class: 'text-center vertical-centered'
				},
				{
					key: 'description',
					label: this.FormMSG(6, 'Description'),
					sortable: true,
					class: 'text-center vertical-centered',
					thStyle: { color: '#fff', width: '250px', minWidth: '100px', maxWidth: '300px' },
					tdStyle: { minWidth: '250px', maxWidth: '300px' }
				},
				{
					key: 'po',
					label: this.FormMSG(7, 'PO'),
					formatter: (v) => v,
					sortable: true,
					class: 'text-center vertical-centered',
					thStyle: { 'min-width': '100px' }
				}
			];
			const supplierField = {
				key: 'supplierName',
				label: this.FormMSG(5, 'Supplier'),
				sortable: true,
				class: 'text-center vertical-centered',
				thStyle: { 'min-width': '150px' }
			};

			const crewField = {
				key: 'crew_member',
				label: this.FormMSG(21, 'Crew Member'),
				sortable: true,
				class: 'text-center vertical-centered',
				thStyle: { 'min-width': '150px' }
			};

			if (this.canSeeCrewMember) {
				fields.splice(1, 0, crewField);
			}

			if (!this.forMultipleInvoice) {
				if (!this.forEfcDraft && !this.forEfcSubmitted) fields.splice(3, 0, supplierField);

				fields.splice(1, 0, {
					key: 'validatedStatus',
					label: this.FormMSG(8, 'Approvals'),
					sortable: true,
					class: 'text-center vertical-centered',
					thStyle: { 'min-width': '100px' }
				});
			}
			fields.push({
				key: 'amountTotal',
				label: this.FormMSG(9, 'Amount'),
				formatter: (v) => rendCurrency(v),
				sortable: true,
				thClass: 'text-center',
				class: 'text-right vertical-centered'
			});

			const selectField = {
				key: 'select',
				class: 'text-center vertical-centered',
				thStyle: { width: '70px' }
			};

			if (!this.forPending && !this.forApproved && !this.forEfcSubmitted) fields.unshift(selectField);

			return fields;
		},
		currentRouteQueryTabs() {
			return this.$route.query.tabs;
		},
		getInvoiceStatusMenu() {
			return this.FormMenu(INVOICE_MENUS.STATUS);
		}
	},
	methods: {
		isInvoiceRefused(item) {
			return [VALIDATION_TYPE.REFUSED_LEVEL_1, VALIDATION_TYPE.REFUSED_LEVEL_2].includes(item.validated);
		},
		async reinitializeFilterInvoices() {
			this.filter = '';
			const actionForLoader = async () => {
				await this.initData();
			};
			this.$nextTick(async () => {
				await this.showLoader(actionForLoader, null);
			});
		},
		approveInvoice(invoice) {
			this.$emit('approveInvoice', invoice);
		},
		sendInvoiceForApproval(invoice) {
			this.$emit('sendInvoiceForApproval', invoice);
		},
		rejectInvoice(invoice) {
			this.rejectComment = '';
			this.selectedInvoice = invoice;
			this.modalRejectedInvoice = true;
		},
		deleteInvoice(invoices) {
			const action = () => {
				let invoiceIds = invoices.map((x) => +x.id);
				deleteExpenses(invoiceIds).then(async () => {
					if (this.forMultipleInvoice) {
						this.$emit('row:delete', invoiceIds);
						this.invoicesItems = this.invoicesItems.filter((invoice) => !invoiceIds.includes(+invoice.id));
					} else {
						await this.initData();
					}
					this.createToastForMobile(this.FormMSG(30, 'Success'), this.FormMSG(29, 'Deleting invoices, Done'));
				});
			};
			this.confirmModal(action, this.FormMSG(269, 'Are you sure to delete these invoices?'), '', 'danger');
		},
		async finaliseInvoiceReject() {
			const ids = this.selectedRows.map((item) => parseInt(item.id));
			const comment = this.rejectComment;
			try {
				const isRejected = await rejectExpenses(ids, comment);
				if (isRejected) this.initData();
			} catch (error) {
				console.log('Error on call service rejectExpenses >>>', error);
			}
			this.modalRejectedInvoice = false;
		},
		async filterInvoices() {
			const actionForLoader = async () => {
				await this.initData();
			};
			this.$nextTick(async () => {
				await this.showLoader(actionForLoader, null);
			});
		},
		async initData() {
			try {
				// reinitialize selections
				this.isBusy = true;
				this.selectedRows = [];
				this.emitSelection();

				let newFilterActive = {
					type: EXPENSE_TYPE.INVOICE,
					recordOffSet: this.offset,
					recordLimit: this.limit,
					keyWord: this.filter
				};

				// initialize data
				if (this.invoiceList.length > 0 && this.forMultipleInvoice) {
					this.invoicesItems = _.cloneDeep(this.invoiceList);
				} else {
					if (this.forApprove) {
						const records = await getExpenseToValidate(newFilterActive);
						this.invoicesItems = this.provideCleanInvoice(records);
					} else if (this.forDraft) {
						const records = await getMyExpenses(null, newFilterActive);
						const filteredRecords = records.filter((item) =>
							[VALIDATION_TYPE.NOT_SUBMITTED, VALIDATION_TYPE.REFUSED_LEVEL_1, VALIDATION_TYPE.REFUSED_LEVEL_2].includes(item.validated)
						);
						this.invoicesItems = this.provideCleanInvoice(filteredRecords);
					} else if (this.forPending) {
						const records = await getMyExpenses(null, newFilterActive);
						const filteredRecords = records.filter((item) =>
							[VALIDATION_TYPE.SUBMITTED, VALIDATION_TYPE.VALIDATED_LEVEL_1].includes(item.validated)
						);
						this.invoicesItems = this.provideCleanInvoice(filteredRecords);
					} else if (this.forApproved || this.forMultipleInvoice) {
						const records = await getMyExpenses(VALIDATION_TYPE.VALIDATED_LEVEL_2, newFilterActive);
						this.invoicesItems = this.provideCleanInvoice(records);
					} else if (this.forEfcDraft) {
						const records = await getInvoiceEntryForCrew(newFilterActive);
						this.invoicesItems = this.provideCleanInvoice(records);
					} else if (this.forEfcSubmitted) {
						const records = await getInvoiceEntryForCrew(newFilterActive, true);
						this.invoicesItems = this.provideCleanInvoice(records);
					}
				}

				this.isBusy = false;
			} catch (error) {
				console.log(error);
				this.isBusy = false;
			}
		},
		provideCleanInvoice(records) {
			const newRecords = records.map((invoice) => {
				return {
					...invoice,
					validatedStatus: this.getValidatedText(invoice.validated),
					typeString: this.getTypeText(invoice.type),
					_rowVariant: '',
					validatedClass: this.getValidatedColor(invoice.validated),
					statusClass: this.getStatusClass(invoice.validated),
					selectState: false
				};
			});

			return newRecords;
		},
		openReviewMode() {
			this.$emit('open:review-mode', this.invoicesItems);
		},
		async viewInvoiceDetails(invoice, index) {
			this.isLoading = true;
			if (this.forApprove && this.$screen.width > 992) {
				this.$emit('open:details', this.invoicesItems, index);
				this.isLoading = false;
			} else {
				try {
					const isForEfc = !this.forMultipleInvoice && (this.forEfcDraft || this.forEfcSubmitted);
					const invoicePayload = await this.preprareDetailsPayload(invoice, isForEfc);
					this.$emit('open:details', invoicePayload);
					this.isLoading = false;
				} catch (error) {
					console.log('Error on getting Details for invoice: ', error);
					this.isLoading = false;
				}
			}
		},
		updateSelectedRows(selectedItem) {
			const foundIndex = this.selectedRows.findIndex((x) => x.id === selectedItem.id);
			if (foundIndex !== -1) {
				this.selectedRows.splice(foundIndex, 1);
			} else this.selectedRows.push(selectedItem);

			this.isSelectedAll = this.selectedRows.length === this.invoicesItems.length;

			this.emitSelection();
		},
		setSelectionForAll() {
			if (this.selectedRows.length !== this.invoicesItems.length) {
				this.selectedRows = _.cloneDeep(this.invoicesItems);
				this.invoicesItems = this.invoicesItems.map((x) => {
					return { ...x, selectState: true };
				});
			} else {
				this.selectedRows = [];
				this.invoicesItems = this.invoicesItems.map((x) => {
					return { ...x, selectState: false };
				});
			}

			this.emitSelection();
		},
		emitSelection() {
			let element = '';
			this.forApprove ? (element = 'approve') : (element = 'draft');
			this.$emit('selection:change', this.selectedRows, element);
		},
		setSelectedItem(event) {
			this.selectedRows = event;
		},
		getValidatedText(validationStatus) {
			return this.GetTextFromMenuNumberAndMenuValue(FINANCES.VALIDATED_MENU, validationStatus);
		},
		getTypeText(type) {
			return this.GetTextFromMenuNumberAndMenuValue(FINANCES.EXPENSE_TYPE_MENU, type);
		},
		getValidatedColor(validationStatus) {
			switch (validationStatus) {
				case 1:
					return 'primary';
				case 2:
					return 'warning';
				case 8:
					return 'success';
				case 4:
					return 'danger';
				case 16:
					return 'danger';

				default:
					return 'info';
			}
		},
		getStatusClass(validationStatus) {
			switch (validationStatus) {
				case 1:
					return 'info';
				case 2:
					return 'pending';
				case 8:
					return 'validated';
				case 4:
					return 'refused';
				case 16:
					return 'refused';

				default:
					return 'not-submitted';
			}
		},
		getInvoiceStatusText(status) {
			return this.GetTextFromMenuNumberAndMenuValue(INVOICE_MENUS.STATUS, status);
		},
		getInvoiceStatusClass(status) {
			switch (status) {
				case 1:
					return 'text-danger';
				case 2:
					return 'text-success';

				default:
					return '';
			}
		}
	},
	watch: {
		canApprove: {
			async handler(newVal) {
				await this.initData();
			}
		}
	}
};
</script>

<style lang="scss" scoped>
:deep(.vertical-centered) {
	vertical-align: middle !important;
}

:deep(.tr-cursor) {
	cursor: pointer !important;
}

.warning-invoice {
	color: #bc9581;
	border-color: #bc9581;
}

.text-description-overflow-ellypsis {
	max-height: 40px;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2; /* Ensure line clamp works */
}

#select-all .custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border: 2px solid #fff;
	background-color: #00a09c;
}

#filterInput {
	border-top-left-radius: 8px;
	border-bottom-left-radius: 8px;
}
.input-group-text {
	border-top-right-radius: 8px;
	border-bottom-right-radius: 8px;
}
</style>
